.tags {
  display: flex;
  padding-top: 12px;
  max-width: 100%;
  flex-wrap: wrap;
  gap: 8px;
  .tag-item {
    display: flex;
    height: 32px;
    box-sizing: border-box;
    align-items: center;
    gap: 4px;
    padding: 6px 12px;
    background-color: var(--gray-200);
    border: 1px solid var(--gray-200);
    border-radius: 16px;
    color: var(--gray-700);
    cursor: pointer;
    font-size: 14px;
    line-height: 20px;
    font-weight: bold;
    max-width: 50%;

    @media (max-width: 600px) {
      max-width: 100%;
    }
  }

  .tag-item:hover {
    border-color: var(--gray-600);
  }

  .tag-positive {
    background-color: #e5f8e6;
    svg {
      path {
        fill: var(--green-dark);
      }
    }
  }

  .tag-positive:hover {
    border-color: var(--green-dark);
  }

  .tag-negative {
    background-color: #ffecec;
    svg {
      path {
        fill: var(--red-dark);
      }
    }
  }
  .tag-negative:hover {
    border-color: var(--red-dark);
  }
}
